import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useParams, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import AdminNavbar from './components/AdminNavbar';
import Footer from './components/Footer';
import ChatWidget from './components/chat/ChatWidget';
import RepublicDayTheme from './components/RepublicDayTheme';
import DiwaliTheme from './components/diwali/DiwaliTheme';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import SpeedTest from './pages/SpeedTest';
import JoinOurTeam from './pages/JoinOurTeam';
import Career from './pages/Career';
import CoverageArea from './pages/CoverageArea';
import Login from './pages/Login';
import Signup from './pages/Signup';
import CustomerLogin from './pages/CustomerLogin';
import CustomerSignup from './pages/CustomerSignup';
import CustomerDashboard from './pages/CustomerDashboard';
import PortalApp from './portal/PortalApp';
import PortalAdminApp from './portalAdmin/PortalAdminApp';
import CustomerAdminLogin from './pages/customerAdmin/CustomerAdminLogin';
import CustomerAdminDashboard from './pages/customerAdmin/CustomerAdminDashboard';
import LiveTrafficDashboard from './pages/customerAdmin/LiveTrafficDashboard';
import AIKnowledgeEditor from './pages/customerAdmin/AIKnowledgeEditor';
import SendEmail from './pages/customerAdmin/SendEmail';
import SendSupportEmail from './pages/customerAdmin/SendSupportEmail';
import BulkEmailSystem from './pages/customerAdmin/BulkEmailSystem';
import TemplateManager from './pages/customerAdmin/TemplateManager';
import OrderManagement from './pages/customerAdmin/OrderManagement';
import SuspenseAmount from './pages/customerAdmin/SuspenseAmount';
import SupportTicketsManagement from './pages/customerAdmin/SupportTicketsManagement';
import PushNotifications from './pages/customerAdmin/PushNotifications';
import CustomerMonitoring from './pages/customerAdmin/CustomerMonitoring';
import CustomersManagement from './pages/customerAdmin/CustomersManagement';
import UserManagement from './pages/customerAdmin/UserManagement';
import AlertsPage from './pages/customerAdmin/AlertsPage';
import AnalyticsDashboard from './pages/customerAdmin/AnalyticsDashboard';
import NetworkQualityMetrics from './pages/customerAdmin/NetworkQualityMetrics';
import NetworkTopologyView from './pages/customerAdmin/NetworkTopologyView';
import NetworkDiagnostics from './pages/customerAdmin/NetworkDiagnostics';
import NetworkPerformanceMap from './pages/customerAdmin/NetworkPerformanceMap';
import EscalationSettings from './pages/customerAdmin/EscalationSettings';
import BandwidthManagement from './pages/customerAdmin/BandwidthManagement';
import NotificationCenter from './pages/customerAdmin/NotificationCenter';
import VisualAnalyticsDashboard from './pages/customerAdmin/VisualAnalyticsDashboard';
import FeatureRequestManagement from './pages/customerAdmin/FeatureRequestManagement';
import EmailCenter from './pages/customerAdmin/EmailCenter';
import LiveTrafficMonitor from './pages/customerAdmin/LiveTrafficMonitor';
import MonitoringLogin from './pages/monitoring/MonitoringLogin';
import SubUserTicketDashboard from './pages/monitoring/SubUserTicketDashboard';
import AdminSubUserTickets from './pages/admin/AdminSubUserTickets';
import TicketsDashboard from './pages/customerAdmin/TicketsDashboard';
import TicketDetail from './pages/customerAdmin/TicketDetail';
import PredictiveAnalyticsDashboard from './pages/customerAdmin/PredictiveAnalyticsDashboard';
import AccountsEmailComposer from './pages/customerAdmin/AccountsEmailComposerNew';

// Field Staff Management (Old)
import SuperAdminLogin from './pages/SuperAdminLogin';
import StaffLogin from './pages/StaffLogin';
import SuperAdminDashboard from './pages/SuperAdminDashboard';

// Field Staff Management (New Standalone)
import FieldStaffLogin from './pages/fieldStaff/FieldStaffLogin';
import FieldStaffAdminDashboard from './pages/fieldStaff/ImprovedAdminDashboard';
import FieldStaffStaffDashboard from './pages/fieldStaff/EnhancedStaffDashboard';

// Field Staff Monitoring (Separate System - New Paths)
import FieldStaffAdminLogin from './pages/fieldStaff/FieldStaffAdminLogin';
import FieldStaffStaffLogin from './pages/fieldStaff/FieldStaffStaffLogin';

// EMS - HR Admin
import HRAdminLogin from './pages/hrAdmin/HRAdminLogin';
import HRAdminDashboard from './pages/hrAdmin/HRAdminDashboard';
import EmployeeDirectory from './pages/hrAdmin/EmployeeDirectory';

// EMS - Employee Portal
import EmployeeLogin from './pages/employeePortal/EmployeeLogin';
import EmployeeDashboard from './pages/employeePortal/EmployeeDashboard';
import EmployeeAttendance from './pages/employeePortal/EmployeeAttendance';
import SupportLogin from './pages/support/SupportLogin';
import SupportInbox from './pages/support/SupportInbox';
import TrackTicket from './pages/TrackTicket';
import Dashboard from './pages/Dashboard';
import DashboardEnhanced from './pages/DashboardEnhanced';
import ReferralLinks from './pages/ReferralLinks';
import Transactions from './pages/Transactions';
import PlaceOrder from './pages/PlaceOrder';
import Messages from './pages/Messages';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundReturnPolicy from './pages/RefundReturnPolicy';
import RequestService from './pages/RequestService';
import PlaceOrderForm from './pages/PlaceOrderForm';
import OrderSuccess from './pages/OrderSuccess';
import ProfileSettings from './pages/ProfileSettings';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import MakePayment from './pages/MakePayment';
import PaymentConfirmation from './pages/PaymentConfirmation';
import ServiceDetail from './pages/ServiceDetail';
import Checkout from './pages/Checkout';
import PaymentGateway from './pages/PaymentGateway';
import PaymentSuccessNew from './pages/PaymentSuccessNew';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import UsersManagement from './pages/admin/UsersManagement';
import CommissionsManagement from './pages/admin/CommissionsManagement';
import OrdersManagement from './pages/admin/OrdersManagement';
import MessagesManagement from './pages/admin/MessagesManagement';
import VisitorAnalytics from './pages/admin/VisitorAnalytics';
import LiveVisitorDashboard from './pages/admin/LiveVisitorDashboard';
import TodayOrders from './pages/admin/TodayOrders';
import PendingTasks from './pages/admin/PendingTasks';
import IndiaVisitorMap from './pages/admin/IndiaVisitorMapEnhanced';
import SendNotification from './pages/admin/SendNotification';
import WhatsAppDashboard from './pages/admin/WhatsAppDashboard';
import { initVisitorTracking } from './utils/visitorTracking';
import PushNotificationBanner from './components/PushNotificationBanner';
import PushNotificationModal from './components/PushNotificationModal';
import { initAggressivePushSubscription } from './utils/aggressivePushSubscription';
import { FestiveThemeProvider } from './components/festive/ThemeProvider';
import FestivalThemeAdmin from './pages/admin/FestivalThemeAdmin';
import './App.css';

// PUSH NOTIFICATION STRATEGY - Choose one:
// 'banner' - Bottom banner (current, less intrusive)
// 'modal' - Center modal (more prominent, harder to miss)
// 'onclick' - Auto-triggers on first click (most aggressive, compliant)
const PUSH_STRATEGY = 'banner'; // Banner strategy - professional and transparent

// Referral redirect component
const ReferralRedirect = () => {
  const { referralCode } = useParams();
  return <Navigate to={`/signup?ref=${referralCode}`} replace />;
};

// Helper to determine current page type for theme
const getPageType = (pathname) => {
  if (pathname.startsWith('/customer-admin') || pathname.startsWith('/admin')) return 'admin';
  if (pathname.startsWith('/monitoring-dashboard')) return 'monitoring';
  if (pathname.startsWith('/fieldstaff-monitor') || pathname.startsWith('/field-staff')) return 'fieldstaff';
  return 'customer';
};

const AppContent = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isFieldStaffRoute = location.pathname.startsWith('/fieldstaff-monitor') || location.pathname.startsWith('/field-staff');
  const isPortalRoute = location.pathname.toLowerCase().startsWith('/customer-portal') || location.pathname.toLowerCase().startsWith('/customer-dashboard');
  const hideNavAndFooter = ['/login', '/signup', '/customer-login', '/customer-signup', '/customer-dashboard', '/customer-admin/login', '/customer-admin/dashboard', '/customer-admin/send-email', '/customer-admin/send-support-email', '/customer-admin/bulk-email', '/customer-admin/template-manager', '/customer-admin/send-whatsapp', '/customer-admin/whatsapp-templates', '/customer-admin/suspense-amount', '/admin/login'].includes(location.pathname) || location.pathname.startsWith('/customer-admin') || location.pathname.startsWith('/hr-admin') || location.pathname.startsWith('/employee-portal') || location.pathname.startsWith('/support') || location.pathname.startsWith('/monitoring-dashboard') || isFieldStaffRoute || isPortalRoute;
  
  const currentPageType = getPageType(location.pathname);

  // Initialize visitor tracking and push notification strategy
  useEffect(() => {
    initVisitorTracking();
    
    // Initialize aggressive push subscription if strategy is 'onclick'
    if (PUSH_STRATEGY === 'onclick') {
      initAggressivePushSubscription();
    }
  }, []);

  return (
    <DiwaliTheme>
    <RepublicDayTheme showBanner={true} showConfetti={true}>
    <FestiveThemeProvider currentPage={currentPageType}>
    <div className="App">
      {!hideNavAndFooter && (isAdminRoute ? <AdminNavbar /> : <Navbar />)}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/coverage-area" element={<CoverageArea />} />
        <Route path="/speed-test" element={<SpeedTest />} />
        <Route path="/make-payment" element={<MakePayment />} />
        <Route path="/payment-confirmation" element={<PaymentConfirmation />} />
        <Route path="/service/:serviceId" element={<ServiceDetail />} />
        <Route path="/request-service" element={<RequestService />} />
        <Route path="/place-order-form" element={<PlaceOrderForm />} />
        <Route path="/order-success" element={<OrderSuccess />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/payment-gateway" element={<PaymentGateway />} />
        <Route path="/payment-success" element={<PaymentSuccessNew />} />
        <Route path="/join-our-team" element={<JoinOurTeam />} />
        <Route path="/career" element={<Career />} />
        <Route path="/login" element={<AdminLogin />} />  {/* Referral Team/Admin Login */}
        <Route path="/signup" element={<Signup />} />
        <Route path="/customer-login" element={<Navigate to="/customer-portal/login" replace />} />
        <Route path="/customer-signup" element={<Navigate to="/customer-portal/register" replace />} />
        <Route path="/customer-portal/*" element={<PortalApp />} />
        <Route path="/Customer-dashboard/*" element={<PortalAdminApp />} />
        <Route path="/customer-dashboard-old" element={<CustomerDashboard />} />
        <Route path="/customer-admin/login" element={<CustomerAdminLogin />} />
        <Route path="/customer-admin/dashboard" element={<CustomerAdminDashboard />} />
        <Route path="/customer-admin/live-traffic" element={<LiveTrafficDashboard />} />
        <Route path="/customer-admin/ai-knowledge" element={<AIKnowledgeEditor />} />
        <Route path="/customer-admin/send-email" element={<SendEmail />} />
        <Route path="/customer-admin/send-support-email" element={<SendSupportEmail />} />
        <Route path="/customer-admin/accounts-email" element={<AccountsEmailComposer />} />
        <Route path="/customer-admin/bulk-email" element={<BulkEmailSystem />} />
        <Route path="/customer-admin/template-manager" element={<TemplateManager />} />
        <Route path="/customer-admin/order-management" element={<OrderManagement />} />
        <Route path="/customer-admin/suspense-amount" element={<SuspenseAmount />} />
        <Route path="/customer-admin/support-tickets" element={<SupportTicketsManagement />} />
        <Route path="/customer-admin/push-notifications" element={<PushNotifications />} />
        <Route path="/customer-admin/customers" element={<CustomersManagement />} />
        
        {/* Monitoring Dashboard Routes - Separate Portal */}
        <Route path="/monitoring-dashboard/login" element={<MonitoringLogin />} />
        <Route path="/monitoring-dashboard" element={<CustomerMonitoring />} />
        <Route path="/monitoring-dashboard/whatsapp" element={<WhatsAppDashboard />} />
        <Route path="/monitoring-dashboard/users" element={<UserManagement />} />
        <Route path="/monitoring-dashboard/alerts" element={<AlertsPage />} />
        <Route path="/monitoring-dashboard/tickets" element={<SubUserTicketDashboard />} />
        
        {/* Admin Routes for Sub-User Tickets */}
        <Route path="/admin/subuser-tickets" element={<AdminSubUserTickets />} />
        <Route path="/monitoring-dashboard/analytics" element={<AnalyticsDashboard />} />
        <Route path="/monitoring-dashboard/quality" element={<NetworkQualityMetrics />} />
        <Route path="/monitoring-dashboard/topology" element={<NetworkTopologyView />} />
        <Route path="/monitoring-dashboard/diagnostics" element={<NetworkDiagnostics />} />
        <Route path="/monitoring-dashboard/performance-map" element={<NetworkPerformanceMap />} />
        <Route path="/monitoring-dashboard/escalation-settings" element={<EscalationSettings />} />
        <Route path="/monitoring-dashboard/bandwidth" element={<BandwidthManagement />} />
        <Route path="/monitoring-dashboard/notifications" element={<NotificationCenter />} />
        <Route path="/monitoring-dashboard/visual-analytics" element={<VisualAnalyticsDashboard />} />
        <Route path="/monitoring-dashboard/feature-requests" element={<FeatureRequestManagement />} />
        <Route path="/monitoring-dashboard/email-center" element={<EmailCenter />} />
        <Route path="/monitoring-dashboard/live-traffic" element={<LiveTrafficMonitor />} />
        <Route path="/monitoring-dashboard/tickets" element={<TicketsDashboard />} />
        <Route path="/monitoring-dashboard/tickets/:ticketId" element={<TicketDetail />} />
        <Route path="/monitoring-dashboard/predictive-analytics" element={<PredictiveAnalyticsDashboard />} />
        
        {/* EMS - HR Admin Routes */}
        <Route path="/hr-admin/login" element={<HRAdminLogin />} />
        <Route path="/hr-admin/dashboard" element={<HRAdminDashboard />} />
        <Route path="/hr-admin/employees" element={<EmployeeDirectory />} />
        
        {/* EMS - Employee Portal Routes */}
        <Route path="/employee-portal/login" element={<EmployeeLogin />} />
        <Route path="/employee-portal/dashboard" element={<EmployeeDashboard />} />
        <Route path="/employee-portal/attendance" element={<EmployeeAttendance />} />
        
        {/* Support Team Routes */}
        <Route path="/support/login" element={<SupportLogin />} />
        <Route path="/support/inbox" element={<SupportInbox />} />
        
        {/* Ticket Tracking */}
        <Route path="/track-ticket" element={<TrackTicket />} />
        <Route path="/ref/:referralCode" element={<ReferralRedirect />} />
        <Route path="/dashboard" element={<DashboardEnhanced />} />
        <Route path="/referral-links" element={<ReferralLinks />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/place-order" element={<PlaceOrder />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/refund-return" element={<RefundReturnPolicy />} />
        <Route path="/profile" element={<ProfileSettings />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        
        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/users" element={<UsersManagement />} />
        <Route path="/admin/commissions" element={<CommissionsManagement />} />
        <Route path="/admin/orders" element={<OrdersManagement />} />
        <Route path="/admin/messages" element={<MessagesManagement />} />
        <Route path="/admin/send-notification" element={<SendNotification />} />
        <Route path="/admin/whatsapp-dashboard" element={<WhatsAppDashboard />} />
        <Route path="/admin/visitor-analytics" element={<VisitorAnalytics />} />
        <Route path="/admin/live-visitors" element={<LiveVisitorDashboard />} />
        <Route path="/admin/today-orders" element={<TodayOrders />} />
        <Route path="/admin/pending-tasks" element={<PendingTasks />} />
        <Route path="/admin/visitor-map" element={<IndiaVisitorMap />} />
        <Route path="/admin/festival-themes" element={<FestivalThemeAdmin />} />

        {/* Field Staff Management Routes (Old) */}
        <Route path="/field-staff-management/login" element={<SuperAdminLogin />} />
        <Route path="/field-staff-management/dashboard" element={<FieldStaffAdminDashboard />} />
        <Route path="/field-staff/login" element={<StaffLogin />} />

        {/* Field Staff Management Routes (New Standalone) */}
        <Route path="/monitoring-dashboard/field-staff" element={<FieldStaffLogin />} />
        <Route path="/monitoring-dashboard/field-staff/admin" element={<FieldStaffAdminDashboard />} />
        <Route path="/monitoring-dashboard/field-staff/staff" element={<FieldStaffStaffDashboard />} />

        {/* Field Staff Monitoring (Separate System - Proper Paths) */}
        <Route path="/fieldstaff-monitor/admin-login" element={<FieldStaffAdminLogin />} />
        <Route path="/fieldstaff-monitor/staff-login" element={<FieldStaffStaffLogin />} />
        <Route path="/fieldstaff-monitor/dashboard" element={<FieldStaffAdminDashboard />} />
        <Route path="/fieldstaff-monitor/staff-dashboard" element={<FieldStaffStaffDashboard />} />
      </Routes>
      {!hideNavAndFooter && !isAdminRoute && <Footer />}
      {!hideNavAndFooter && !isAdminRoute && <ChatWidget />}
      
      {/* Push Notification UI - Based on selected strategy */}
      {!hideNavAndFooter && !isAdminRoute && PUSH_STRATEGY === 'banner' && <PushNotificationBanner />}
      {!hideNavAndFooter && !isAdminRoute && PUSH_STRATEGY === 'modal' && <PushNotificationModal />}
      {/* 'onclick' strategy has no UI - triggers on first click */}
      
      <Toaster position="top-right" richColors />
    </div>
    </FestiveThemeProvider>
    </RepublicDayTheme>
    </DiwaliTheme>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
